import React from 'react';
import ApexChart from 'react-apexcharts';
import type { ApexOptions } from 'apexcharts';
import { useSelector } from 'react-redux';
import { merge } from 'lodash';
import { getApexTheme } from '../../utils/theme/getApexTheme';


interface BaseApexChartProps {
    options: any;
    series: ApexAxisChartSeries | ApexNonAxisChartSeries;
    type: 'line' | 'area' | 'bar' | 'donut' | 'radialBar' | 'pie' | 'scatter' | 'heatmap'; // add others as needed
    width?: number | string;
    height?: number | string;
}

const BaseApexChart: React.FC<BaseApexChartProps> = ({ options = {}, series, ...rest }) => {
    const { theme } = useSelector((state: any) => state.theme);
    const baseOptions = getApexTheme(theme);

    const mergedOptions = merge({}, baseOptions, options);

    return <ApexChart {...rest} series={series} options={mergedOptions} />;
};

export default BaseApexChart;